<div
  class="general animal-group__child spacing--padding-all spacing--margin-all"
  data-test="general"
>
  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="flex--column">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'animal-group.general.name' | translate }}</mat-label>
        <input
          matInput
          placeholder="{{ 'animal-group.general.name' | translate }}"
          formControlName="name"
          data-test="general__animal-group-name"
        />
        <mat-error *ngIf="form.controls.name.errors?.required">
          {{ 'required-error' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'animal-group.general.description' | translate }}</mat-label>
        <textarea
          matInput
          placeholder="{{ 'animal-group.general.description' | translate }}"
          formControlName="description"
          data-test="general__description"
        >
        </textarea>
        <mat-error *ngIf="form.controls.description.errors?.required">
          {{ 'required-error' | translate }}
        </mat-error>
      </mat-form-field>

      <div class="flex--row flex--gutter">
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'animal-group.general.production-type' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            placeholder="{{ 'animal-group.general.production-type' | translate }}"
            formControlName="productionType"
            data-test="general__production-type"
          >
            <mat-option *ngFor="let productionType of productionTypes" [value]="productionType">
              {{ 'productionType.' + productionType | translate }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.productionType.errors?.required">
            {{ 'required-error' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'animal-group.general.start-date' | translate }}</mat-label>
          <input
            formControlName="startDate"
            matInput
            [matDatepicker]="startDatePicker"
            placeholder="{{ 'animal-group.general.start-date' | translate }}"
            data-test="general__start-date"
          />
          <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #startDatePicker></mat-datepicker>
          <mat-error *ngIf="form.controls.startDate.errors?.required">
            {{ 'required-error' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'animal-group.general.end-date' | translate }}</mat-label>
          <input
            formControlName="endDate"
            matInput
            [matDatepicker]="endDatePicker"
            placeholder="{{ 'animal-group.general.end-date' | translate }}"
            data-test="general__end-date"
          />
          <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #endDatePicker></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="flex--row flex--gutter">
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'animal-group.general.system-type' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            placeholder="{{ 'animal-group.general.system-type' | translate }}"
            formControlName="supplySystemType"
            data-test="general__system-type"
          >
            <mat-option *ngFor="let systemType of systemTypes" [value]="systemType">
              {{ 'systemType.' + systemType | translate }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.supplySystemType.errors?.required">
            {{ 'required-error' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto" *ngIf="barns$ | async as barns">
          <mat-label>{{ 'animal-group.general.barn' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            placeholder="{{ 'animal-group.general.barn' | translate }}"
            formControlName="barn"
            data-test="general__barn"
            [compareWith]="areBarnsEqual"
            (selectionChange)="setSelectedBarn($event)"
          >
            <mat-option *ngFor="let barn of barns" [value]="barn">
              {{ barn.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.barn.errors?.required">
            {{ 'required-error' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'animal-group.general.sections' | translate }}</mat-label>
          <mat-select
            multiple
            placeholder="{{ 'animal-group.general.sections' | translate }}"
            formControlName="sectionNames"
            data-test="general__sections"
          >
            <ng-container *ngIf="!!(selectedBarn$ | async)?.properties?.sections">
              <mat-option
                *ngFor="let section of (selectedBarn$ | async)?.properties.sections"
                [value]="section"
              >
                {{ section }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="spacing--margin-top mat-button-row">
        <button
          type="submit"
          mat-flat-button
          class="flex__child"
          color="primary"
          data-test="general__save"
        >
          {{ 'save' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
